import { render, staticRenderFns } from "./IconTransactions.vue?vue&type=template&id=454ba28d&functional=true"
import script from "./IconTransactions.vue?vue&type=script&lang=js"
export * from "./IconTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports